// extracted by mini-css-extract-plugin
export default {"customStyColorPicker":"disclaimer_customStyColorPicker__G+XI-","customColorPicker":"disclaimer_customColorPicker__MQehn","btnReset":"disclaimer_btnReset__fML9M"};